<template>
  <div>
    <div :key="ind" v-for="(item, ind) in arrayValues" class="flex">
      <el-input
        :key="key"
        v-for="(value, key) in item"
        class="input-new-tag"
        :value="value"
        @input="update($event, key, item)"
        size="small"
        :disabled="options && options.disabled"
      />
      <el-button
        type="danger"
        class="button-new-tag"
        size="small"
        :style="{
          width: `${buttonWidth}px`,
        }"
        @click="handleClose(ind)"
        >{{ buttonNameRemove }}</el-button
      >
    </div>
    <div class="flex">
      <el-input
        :key="i"
        v-for="(item, i) in fields"
        class="input-new-tag"
        v-model="fieldsValues[i]"
        size="small"
        :placeholder="item.title"
        :type="item.type"
        :ref="`input-${i}`"
        :required="item.required"
        :class="!item.required ? 'not-required' : ''"
      >
      </el-input>
      <el-button
        class="button-new-tag"
        size="small"
        :style="{
          width: `${buttonWidth}px`,
        }"
        @click="addButton"
        >{{ buttonNameAdd }}</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    fields: {
      type: Object,
      required: true,
      default: () => {},
    },
    options: {
      type: Object,
      required: false,
      default: () => {},
    },
    buttonNameAdd: {
      type: String,
      required: false,
      default: "+",
    },
    buttonNameRemove: {
      type: String,
      required: false,
      default: "-",
    },
    buttonWidth: {
      type: Number,
      required: false,
      default: 50,
    },
  },
  computed: {
    arrayValues: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      fieldsValues: {},
    };
  },
  created() {
    this.createValues();
  },
  methods: {
    createValues() {
      let keys = Object.keys(this.fields);
      for (let key of keys) {
        if (this.fields[key].type == "number")
          this.$set(this.fieldsValues, key, null);
        else this.$set(this.fieldsValues, key, "");
      }
    },
    clearValues() {
      for (let key in this.fieldsValues) this.fieldsValues[key] = "";
    },
    handleClose(ind) {
      this.arrayValues.splice(ind, 1);
    },
    // showInput() {
    //   this.inputVisible = true;
    //   this.$nextTick(() => {
    //     this.$refs.saveTagInput.$refs.input.focus();
    //   });
    // },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        this.$emit("input", this.dynamicTags);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    addButton() {
      for (let key in this.fields) {
        if (this.fields[key].required && !this.fieldsValues[key]) {
          this.$refs[`input-${key}`][0].$el.children[0].classList.add(
            "required"
          );
          return;
        }
      }
      let obj = {};
      Object.assign(obj, this.fieldsValues);
      this.arrayValues.push(obj);
      this.clearValues();
      this.$emit("input", this.arrayValues);
    },
    update(e, key, item) {
      item[key] = e;
    },
  },
};
</script>

<style scoped>
.el-tag {
  margin-right: 10px;
}
.button-new-tag {
  /* margin-right: 10px; */
}
.input-new-tag {
  margin-right: 10px;
  line-height: initial;
}
.grid {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 5px;
  margin-bottom: 5px;
}
.flex {
  display: flex;
  margin-bottom: 5px;
}
.required {
  border-color: red;
}
</style>
